module.exports = __webpack_public_path__ + "img/avatar-85.3e96cc4d.png";